import { Injectable, Signal, computed, signal } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthenticationService } from 'src/app/auth/authentication-service/authentication.service';

/**
 * Interceptor to inject the Authorization header to outbound requests.
 *
 * Only requests to the backend have the header injected.
 */
@Injectable()
export class AuthenticationHeaderAdderInterceptor implements HttpInterceptor {
  protected request?: HttpRequest<unknown>;

  protected _token: Signal<string | null> = signal(null);

  constructor(protected authenticacionService: AuthenticationService) {
    this._token = computed(() => {
      const authData = this.authenticacionService.authData();
      return authData ? authData.token : null;
    });
  }

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    this.request = request;

    if (this._token() && this.isRequestingDataApi()) {
      this.addTokenHeaderToRequest();
    }

    return next.handle(this.request);
  }

  protected isRequestingDataApi(): boolean {
    return !!this.request?.url.includes('/api/chronos');
  }

  protected addTokenHeaderToRequest(): void {
    this.request = this.request?.clone({
      setHeaders: {
        Authorization: `Bearer ${this._token()}`,
      },
    });
  }
}
